'use strict';

var JQXTreeNodeFactory = function JQXTreeNodeFactory() {
  function Node(params) {
    this.id = params.id;
    this.label = params.label;
    this.checked = params.checked;
    this.selected = params.selected;
    this.frozen = params.frozen;
    this.field = params.field;
    // Both false and undefined custom means a predefined column/group
    this.custom = !!params.custom;
  }
  Node.prototype.addFaIcon = function (iconName) {
    this.faIcons = this.faIcons ? this.faIcons + ',' + iconName : iconName;
  };
  return Node;
};
JQXTreeNodeFactory.$inject = [];
module.exports = JQXTreeNodeFactory;